var _class, _helpers;
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { registerDestructor } from "@ember/destroyable";
import Service from "@ember/service";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
let ElementClassesService = disableImplicitInjections(_class = (_helpers = /*#__PURE__*/new WeakMap(), class ElementClassesService extends Service {
  constructor() {
    super(...arguments);
    /** @type Map<Helper, string[]> */
    _classPrivateFieldInitSpec(this, _helpers, new Map());
  }
  registerClasses(helper, element, classes) {
    if (_classPrivateFieldGet(_helpers, this).has(helper)) {
      const previousClasses = _classPrivateFieldGet(_helpers, this).get(helper);
      _classPrivateFieldGet(_helpers, this).set(helper, classes);
      this.removeUnusedClasses(element, previousClasses);
    } else {
      _classPrivateFieldGet(_helpers, this).set(helper, classes);
      registerDestructor(helper, () => {
        const previousClasses = _classPrivateFieldGet(_helpers, this).get(helper);
        _classPrivateFieldGet(_helpers, this).delete(helper);
        this.removeUnusedClasses(element, previousClasses);
      });
    }
    for (const elementClass of classes) {
      element.classList.add(elementClass);
    }
  }
  removeUnusedClasses(element, classes) {
    const remainingClasses = new Set([..._classPrivateFieldGet(_helpers, this).values()].flat());
    for (const elementClass of classes) {
      if (!remainingClasses.has(elementClass)) {
        element.classList.remove(elementClass);
      }
    }
  }
})) || _class;
export { ElementClassesService as default };